<template>
    <div class="rich-text">
        <div class="shadow-box">
            <div v-html="$prismic.asHtml(document.data.quote_header)" /> 
            <div class="quote-answer">
                <div v-html="$prismic.asHtml(document.data.quote_text)" /> 
                <div v-html="$prismic.asHtml(document.data.quote_by)" /> 
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        document: {
            type: Object,
            required: true
        },
    }
};
</script>

<style lang="scss" scoped>
    ::v-deep{
        h2, h3, h4, h5, h6 {
            margin-top: 0px !important;
        }
    }
    .rich-text{
        width: 100%;
    }
    .shadow-box {
    box-shadow: $bxs;
    background: $graybg;
    @include border-radius(15px);
    @include spacing(padding,4);

    .quote-answer{
        @include spacing(padding,4,(left, right));
    }
}
</style>